import React from "react";
import styles from "./companyReportSection.module.scss";
import classNames from "classnames";
import { Divider, Header } from "@fluentui/react-northstar";
import pl from "shared/messages/pl";

interface CompanyReportSectionProps {
    companyName?: string;
    additionalClassName?: string;
    reportContents: React.ReactNode | null;
}

const CompanyReportSection: React.FC<CompanyReportSectionProps> = (props: CompanyReportSectionProps) => {
    return (
        <div className={classNames(styles.wrapper, props.additionalClassName)}>
            {props.reportContents ? (
                <>
                    <Header as="h4" content={props.companyName} className={styles.companyNameHeader} />
                    <Divider />
                    <div>{props.reportContents}</div>
                </>
            ) : (
                <Header as="h3">{pl.reports.noReportsAvailable(props.companyName ?? "")}</Header>
            )}
        </div>
    );
};

export default CompanyReportSection;
